"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const _1 = require(".");
const rePhone = /^[+]?([\s0-9]*$)/;
const reWhitespace = /\s/;
function phoneV(path) {
    return x => {
        const match = x.match(rePhone);
        return match != null && match[1].replace(reWhitespace, '').length >= 6
            ? E.right(x)
            : E.left([
                new _1.ValidationError(path, `${x} is invalid phone number`, new InvalidPhoneInfo()),
            ]);
    };
}
exports.phoneV = phoneV;
class InvalidPhoneInfo {
    constructor() {
        this.type = 'invalidPhone';
    }
}
